<template>
  <fragment>
    <li class="menu-section">
      <h4 class="menu-text">LOGISTICS</h4>
    </li>
    <router-link
      :to="{ name: 'logisticsRequestList' }"
      class="menu-link menu-toggle"
      v-slot="{ href, navigate, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        :class="[isExactActive && 'menu-item-active']"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-list"></i>
          <span class="menu-text">Danh sách yêu cầu</span>
        </a>
      </li>
    </router-link>
    <router-link
      :to="{ name: 'logisticsQuotaManagement' }"
      class="menu-link menu-toggle"
      v-slot="{ href, navigate, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        :class="[isExactActive && 'menu-item-active']"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-chart-line"></i>
          <span class="menu-text">Quản lý hạn mức</span>
        </a>
      </li>
    </router-link>
    <router-link
      :to="{ name: 'logisticsProductManagement' }"
      class="menu-link menu-toggle"
      v-slot="{ href, navigate, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        :class="[isExactActive && 'menu-item-active']"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-box"></i>
          <span class="menu-text">Quản lý mặt hàng</span>
        </a>
      </li>
    </router-link>
    <router-link
      :to="{ name: 'logisticsInvoiceManagement' }"
      class="menu-link menu-toggle"
      v-slot="{ href, navigate, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        :class="[isExactActive && 'menu-item-active']"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-file-invoice-dollar"></i>
          <span class="menu-text">Quản lý hóa đơn</span>
        </a>
      </li>
    </router-link>
    <router-link
        :to="{ name: 'MangeGiftProgram' }"
        class="menu-link menu-toggle"
        v-slot="{ href, navigate, isExactActive }"
    >
      <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item menu-item-submenu"
          :class="[isExactActive && 'menu-item-active']"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-box"></i>
          <span class="menu-text">Quản lý quà tặng</span>
        </a>
      </li>
    </router-link>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Logistics",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route.path.indexOf(match) !== -1;
    },
  },
};
</script>

<style scoped>
</style>
